import React from 'react';
import {
  Navigate,
  Route,
  Routes
} from 'react-router-dom';

import * as ROUTES from '../../constants/routes';
import lazyComponent from '../../hoc/lazyComponent/lazyComponent';
import LandingPage from '../../pages/LandingPage/LandingPage';

import ReactPixel from 'react-facebook-pixel';
import Redirect from '../Util/Redirect';

// Import lazyloading components
const LazyCartPage = lazyComponent(() => {
  return import(/* webpackChunkName: "cart" */ '../../pages/CartPage/CartPage');
});
const LazyNotFoundPage = lazyComponent(() => {
  return import(/* webpackChunkName: "404" */ '../../pages/NotFoundPage/NotFoundPage');
});
const LazyShowPage = lazyComponent(() => {
  return import(/* webpackChunkName: "show" */ '../../pages/ShowPage/ShowPageFunctionWrapper');
});
const LazyCheckoutPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/CheckoutPage/CheckoutPage');
});
const LazyPaymentPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/PaymentPage/PaymentPage');
});
const LazyGiftCardPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/GiftCardPage/GiftCardPage');
});
const LazyEventPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/EventPage/EventPage');
});
const LazyUpcomingShowPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/UpcomingShowPage/UpcomingShowPage');
});

const LazyEventListPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/EventList/EventList');
});
const LazyBlogAutokinoPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/blog/BlogAutokinoPage/BlogAutokinoPage');
});
const LazyBlogFlohmarktPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/blog/BlogFlohmarktPage/BlogFlohmarktPage');
});
const LazyKinderflohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xkinderlohmarkt_wien_sonntag');
});
const LazyGeschichtePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/GeschichtePage');
});
const LazyKundenliebePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/KundenliebePage');
});
const LazyBesuchertippsPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xtipps_und_tricks_fuer_flohmarkt_besucher');
});
const LazyFaqPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xfaqs_flohmarkt_wien_sonntag');
});
const LazyMarktordnungPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xflohmarkt_regeln_marktordnung');
});
const LazyChecklistVerkaeuferPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xchecklist_fuer_flohmarkt_verkaufer');
});
const LazyTippsVerkaeuferPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xtipps_tricks_fuer_deinen_erfolgreichen_flohmarkt_verkauf');
});
const LazyAnreisePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/AnreisePage');
});
const LazyAnreiseNewPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xanreise_gratis_parken');
});

const LazyFotosPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xflohmarkt_heute_fotos');
});
const LazyStandplatzgebuehrenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xflohmarkt_standplaetze_standgebuehren_platzmiete');
});
const LazyBikeFaqPage = lazyComponent(() => {
  return import('../../pages/autokino/BikeFaqPage');
});
const LazyCustomerFeedbackFormPage = lazyComponent(() => {
  return import('../../pages/CustomerFeedbackFormPage/CustomerFeedbackFormPage');
});
const LazySuccessPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/SuccessPage/SuccessPage');
});
const LazyEventLocationPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/EventLocationPage');
});
const LazyAnreiseAutokinoPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/AnreiseAutokinoPage');
});
const LazyFaqAutokinoPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/FaqAutokinoPage');
});
const LazyHaustierePage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/landingpages/Xhunde_kino');
});
const LazyJobsPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/JobsPage');
});
const LazyPhilosophiePage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/PhilosophiePage');
});
const LazyOpenAirKinoPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/landingpages/Xopen_air_kino');
});
const LazySiegerKinotestPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/SiegerKinotestPage');
});
const LazyAutokinoPartnerPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/AutokinoPartnerPage');
});
const LazyDasAutokinoPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/autokino/DasAutokinoPage');
});
const LazyHomePage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/HomePage/HomePage');
});
const LazyMoviePage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/MoviePage/MoviePage');
});
const LazyFlohmarktMistelbachPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/flohmarkt/landingpages/xflohmarkt_mistelbach');
});
const LazyFlohmarktJobsPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/flohmarkt/landingpages/xjob_flohmarkt');
});
const LazyFlohmarktNiederoesterreichPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/flohmarkt/landingpages/xflohmarkt_niederoesterreich');
});
const LazyFlohmarktGaenserndorfPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/flohmarkt/landingpages/xflohmarkt_gaenserndorf');
});
const LazyShowNotFoundPage = lazyComponent(() => {
  return import(/* webpackChunkName: "checkout" */ '../../pages/ShowNotFoundPage/ShowNotFoundPage');
});
const LazyOrderStornoPage = lazyComponent(() => {
  return import('../../pages/OrderStornoPage/OrderStornoPage');
});

const LazyLandingPageMinions4Page = lazyComponent(() => {
  return import('../../pages/autokino/LandingPageMinions4Page');
});
const LazyFMWinterpausePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/FMWinterpausePage');
});
const LazyKinoWinterpausePage = lazyComponent(() => {
  return import('../../pages/autokino/KinoWinterpausePage');
});

const LazyGenericLandingPageAutokinoPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/GenericTestPageAutokino');
});
const LazyGenericLandingPageKinderflohmarktPage = lazyComponent(() => {
  return import('../../pages/kinderflohmarkt/landingpages/GenericTestPageKinderflohmarkt');
});
const LazyGenericLandingPageEventLocationPage = lazyComponent(() => {
  return import('../../pages/eventlocation/landingpages/GenericTestPageEventlocation');
});
const LazyGenericLandingPageMinions4Page = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/GenericTestPage');
});
const LazyJobApplicationSuccessPage = lazyComponent(() => {
  return import('../../pages/JobApplicationSuccessPage/JobApplicationSuccessPage');
});
const LazyAnfaengerFlohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/anfaenger_tipps_flohmarkt');
});
const LazyAnmeldenFlohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/anmelden_flohmarkt');
});
const LazyAusstellerWissenLexikonPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/aussteller_wissens_lexikon');
});
const LazyBabyflohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/Babyflohmarkt');
});
const LazyBestenFlohmaerkteWien = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/bester_flohmarkt_wien');
});
const LazyBesteFlohmaerkteUebersichtPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/bester_flohmarkt');
});
const LazyDiebstahlPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/diebstahl');
});
const LazyDurchschnittlicheEinnahmenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/durchschnittliche_flohmarkt_einnahmen');
});
const LazyErfolgreichHandelnPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/erfolgreich_handeln_am_flohmarkt');
});
const LazyFlohmarktInDerNaehePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/flohmarkt_in_der_naehe');
});
const LazyLeihtischePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/flohmarkt_leihtische');
});
const LazyFlohmarktListePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/flohmarkt_liste');
});
const LazyFlohmarktOhneStandgebuehr = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/flohmarkt_ohne_standgebuehr');
});
const LazyFlohmarktOnlineVergleichenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/flohmarkt_online_vergleichen');
});
const LazyFlohmarktPlatzReservierenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/flohmarkt_platz_reservieren');
});
const LazyPreisgestaltungPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/flohmarkt_ware_preis_gestalten');
});
const LazyGeldverdienenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/geld_verdienen');
});
const LazyGenehmigungAnmeldungPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/genehmigung_anmeldung_flohmarkt');
});
const LazyGewerbeGewerbescheinPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/gewerbe_gewerbeschein');
});
const LazyGroessterFlohmarktWienPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/groesster_flohmarkt_wien');
});
const LazyHobbyFlohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/hobby_flohmarkt');
});
const LazyJetztStandplatzBuchenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/jetzt_flohmarktstand_buchen');
});
const LazyKinderVerkaeuferPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/kinder_als_verkauefer');
});
const LazyKinderflohmarktChecklistePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/kinderflohmarkt_checkliste');
});
const LazyTippsPreisePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/kinderflohmarkt_preise_ware');
});
const LazyFlohmarktPreisePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/kleidung_verkaufen_flohmarkt');
});
const LazyFlohmarktMitmachenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/mitmachen_flohmarkt');
});
const LazyFlohmarktNachhaltigkeitPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/nachhaltigkeit_flohmarkt');
});
const LazyFlohmarktNeuwarePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/neuware_verkaufen');
});
const LazyFlohmarktToolsPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/nuetzliche_flohmarkttools');
});
const LazyPacklisteFlohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/packliste_flohmarkt');
});
const LazyParkplatzFlohmarkt = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/parkplatz_flohmarkt');
});
const LazyPreisschilderFlohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/preisschilder_flohmarkt');
});
const LazyRegenFlohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/regen_flohmarkt');
});
const LazyWarenReinigenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/reinigen_aufbereiten_flohmarktware');
});
const LazyFlohmarktOrganisationPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/sortieren_organisieren');
});
const LazyStandGestaltenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/stand_gestalten_flohmarkt');
});
const LazyStromtesterPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/stromtester');
});
const LazyTippKinderflohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/tipps_verkauf_kinderflohmarkt');
});
const LazyUebrigeWarenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/uebergebliebene_ware');
});
const LazyUmgangKundenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/umgang_flohmarkt_kunden');
});
const LazyVorteileAusstellerPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/vorteile_aussteller_flohmarkt_autokino');
});
const LazyWareLagernPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/ware_lagern');
});
const LazyGuteWarenPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/was_verkauft_sich_gut_auf_flohmaerkten');
});
const LazyWechselgeldPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/wechselgeld_am_flohmarkt');
});
const LazyRichtigerFlohmarktPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/wie_finde_ich_den_richtigen_flohmarkt');
});

const LazyFlohmarktWiePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xxflohmarkt_wie');
});
const LazyFlohmarktTerminePage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/xxflohmarkttermine');
});
const LazyJurrasicWorld = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Jurassic_world');
});
const LazySupermanLegacy = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Superman_kino');
});
const LazyFantasticFour = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Fantastic_four');
});
const LazyDieSchluempfe = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Die_schluempfe');
});
const LazyGangsterGang = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Gangster_gang_2');
});
const LazyF1DerFilm = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/F1_kino');
});
const LazyAusflugszielWien = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Ausflugsziel_wien');
});
const LazyDateIdeenPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Date_ideen_wien');
});
const LazyFamilienausflugKinoPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Familienausflug_kino');
});
const LazyHeuteImKinoPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Heute_im_kino');
});
const LazyKinderKinoPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Kinder_kino');
});
const LazyMaedelsabendKinoPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Maedelsabend_kino');
});
const LazyTopKino2025Page = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Top_kinofilme_2025');
});
const LazyBabykinoPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Baby_im_kino');
});
const LazyFlohmarktStadlauPage = lazyComponent(() => {
  return import('../../pages/flohmarkt/landingpages/zz_flohmarkt_gewerbepark_stadlau_alternative');
});
const LazyAtk2025NeuerungenPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Xxneuerungen_atk_2025');
});
const LazyKinoWieDamalsPage = lazyComponent(() => {
  return import('../../pages/autokino/landingpages/Kino_wie_damals');
});

const trackPageView = () => {
  console.log('PageView Event', window.location.pathname);
  ReactPixel.pageView(window.location.pathname);
};
function RoutesComponent() {
  const location = window.location;
  /*const history = useNavigate();
  ReactGA.send('pageview');
  if (window.location.pathname === '/cart') {
    ReactGA.event('begin_checkout', {});
  }
  React.useEffect(() => {
    trackPageView(); // To track the first pageview upon load
    history.listen(trackPageView); // To track the subsequent pageviews
    if (window.location.pathname === '/cart') {
      ReactPixel.track('InitiateCheckout');
    }
  }, [history]); */

  return (
    <Routes>
      <Route path={ROUTES.LANDING} exact element={<LandingPage />} key="landing" />

      <Route
        path={`${ROUTES.GENERIC_LANDING_PAGE}`}
        element={<LazyGenericLandingPageMinions4Page />}
        exact
        key="genericLandingPage"
      />
      <Route
        path={`${ROUTES.KINO_WIE_DAMALS}`}
        element={<LazyKinoWieDamalsPage />}
        exact
        key="kinoWieDamals"
      />

      <Route
        path={`${ROUTES.GENERIC_LANDING_PAGE_EVENT_LOCATION}`}
        element={<LazyGenericLandingPageEventLocationPage />}
        exact
        key="genericLandingPageEvent"
      />
      <Route
        path={`${ROUTES.GENERIC_LANDING_PAGE_AUTOKINO}`}
        element={<LazyGenericLandingPageAutokinoPage />}
        exact
        key="genericLandingPageAutokino"
      />
      <Route
        path={`${ROUTES.GENERIC_LANDING_PAGE_KINDERFLOHMARKT}`}
        element={<LazyGenericLandingPageKinderflohmarktPage />}
        exact
        key="genericLandingPageKinderflohmarkt"
      />

      <Route
        path={`${ROUTES.FLOHMARKT_STADLAU}`}
        element={<LazyFlohmarktStadlauPage />}
        exact
        key="babyKino"
      />
      <Route
        path={`${ROUTES.ATK_2025_NEUERUNGEN}`}
        element={<LazyAtk2025NeuerungenPage />}
        exact
        key="Autokino 2025 Neuerungen"
      />
      <Route
        path={`${ROUTES.BABYKINO}`}
        element={<LazyBabykinoPage />}
        exact
        key="babyKino"
      />
      <Route
        path={`${ROUTES.TOPKINO_2025}`}
        element={<LazyTopKino2025Page />}
        exact
        key="topkino2025"
      />
      <Route
        path={`${ROUTES.MAEDELSABEND_KINO}`}
        element={<LazyMaedelsabendKinoPage />}
        exact
        key="maedelsabendKino"
      />
      <Route
        path={`${ROUTES.KINDER_KINO}`}
        element={<LazyKinderKinoPage />}
        exact
        key="kinderKino"
      />
      <Route
        path={`${ROUTES.HEUTE_IM_KINO}`}
        element={<LazyHeuteImKinoPage />}
        exact
        key="heuteImKino"
      />
      <Route
        path={`${ROUTES.FAMILIENAUSFLUG_KINO}`}
        element={<LazyFamilienausflugKinoPage />}
        exact
        key="familienAusflugKino"
      />
      <Route
        path={`${ROUTES.DATE_IDEEN_WIEN}`}
        element={<LazyDateIdeenPage />}
        exact
        key="dateIdeenWien"
      />
      <Route
        path={`${ROUTES.AUSFLUGSZIEL_WIEN}`}
        element={<LazyAusflugszielWien />}
        exact
        key="ausflugszielWien"
      />
      <Route
        path={`${ROUTES.JURASSIC_WORLD}`}
        element={<LazyJurrasicWorld />}
        exact
        key="jurassicWorldDieWiedergeburt"
      />
      <Route
        path={`${ROUTES.SUPERMAN_LEGACY}`}
        element={<LazySupermanLegacy />}
        exact
        key="supermanLegacy"
      />
      <Route
        path={`${ROUTES.FANTASTIC_FOUR}`}
        element={<LazyFantasticFour />}
        exact
        key="fantasticFour"
      />
      <Route
        path={`${ROUTES.DIE_SCHLUEMPFE}`}
        element={<LazyDieSchluempfe />}
        exact
        key="dieSchluempfeDerGrosseKinofilm"
      />
      <Route
        path={`${ROUTES.GANGSTER_GANG_2}`}
        element={<LazyGangsterGang />}
        exact
        key="gangsterGang2"
      />
      <Route
        path={`${ROUTES.F1_DERFILM}`}
        element={<LazyF1DerFilm />}
        exact
        key="f1DerFilm"
      />

      <Route
        path={`${ROUTES.RICHTIGER_FLOHMARKT}`}
        element={<LazyRichtigerFlohmarktPage />}
        exact
        key="richtigerFlohmarkt"
      />

      <Route
        path={`${ROUTES.FLOHMARKT_TERMINE}`}
        element={<LazyFlohmarktTerminePage />}
        exact
        key="flohmarktTermine"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_WIE}`}
        element={<LazyFlohmarktWiePage />}
        exact
        key="flohmarktWie"
      />
      <Route
        path={`${ROUTES.WECHSELGELD}`}
        element={<LazyWechselgeldPage />}
        exact
        key="wechselgeld"
      />
      <Route
        path={`${ROUTES.GUTE_WAREN}`}
        element={<LazyGuteWarenPage />}
        exact
        key="guteWaren"
      />
      <Route
        path={`${ROUTES.WARE_LAGERN}`}
        element={<LazyWareLagernPage />}
        exact
        key="wareLagern"
      />
      <Route
        path={`${ROUTES.VORTEILE_AUSSTELLER}`}
        element={<LazyVorteileAusstellerPage />}
        exact
        key="vorteileAussteller"
      />
      <Route
        path={`${ROUTES.UMGANG_KUNDEN}`}
        element={<LazyUmgangKundenPage />}
        exact
        key="umgangKunden"
      />
      <Route
        path={`${ROUTES.UEBRIG_GEBLIEBENE_WAREN}`}
        element={<LazyUebrigeWarenPage />}
        exact
        key="uebrigGebliebeneWaren"
      />
      <Route
        path={`${ROUTES.TIPPS_KINDERFLOHMARKT}`}
        element={<LazyTippKinderflohmarktPage />}
        exact
        key="tippsKinderflohmarkt"
      />
      <Route
        path={`${ROUTES.STROMTESTER}`}
        element={<LazyStromtesterPage />}
        exact
        key="stromtester"
      />
      <Route
        path={`${ROUTES.STAND_GESTALTEN}`}
        element={<LazyStandGestaltenPage />}
        exact
        key="standGestalten"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_ORGANISATION}`}
        element={<LazyFlohmarktOrganisationPage />}
        exact
        key="flohmarktOrganisation"
      />
      <Route
        path={`${ROUTES.WAREN_REINIGEN}`}
        element={<LazyWarenReinigenPage />}
        exact
        key="warenReinigen"
      />
      <Route
        path={`${ROUTES.REGEN_FLOHMARKT}`}
        element={<LazyRegenFlohmarktPage />}
        exact
        key="regenFlohmarkt"
      />
      <Route
        path={`${ROUTES.PREISSCHILDER_FLOHMARKT}`}
        element={<LazyPreisschilderFlohmarktPage />}
        exact
        key="preisschilderFlohmarkt"
      />
      <Route
        path={`${ROUTES.PARKPLATZ_FLOHMARKT}`}
        element={<LazyParkplatzFlohmarkt />}
        exact
        key="parkplatzFlohmarkt"
      />
      <Route
        path={`${ROUTES.PACKLISTE_FLOHMARKT}`}
        element={<LazyPacklisteFlohmarktPage />}
        exact
        key="flohmarktPackliste"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_TOOLS}`}
        element={<LazyFlohmarktToolsPage />}
        exact
        key="flohmarktTools"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_NEUWARE}`}
        element={<LazyFlohmarktNeuwarePage />}
        exact
        key="flohmarktNeuware"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_NACHHALTIGKEIT}`}
        element={<LazyFlohmarktNachhaltigkeitPage />}
        exact
        key="flohmarktNachhaltigkeit"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_MITMACHEN}`}
        element={<LazyFlohmarktMitmachenPage />}
        exact
        key="flohmarktMitmachen"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_PREISE}`}
        element={<LazyFlohmarktPreisePage />}
        exact
        key="flohmarktPreise"
      />
      <Route
        path={`${ROUTES.TIPPS_PREISE}`}
        element={<LazyTippsPreisePage />}
        exact
        key="tippsPreise"
      />
      <Route
        path={`${ROUTES.KINDER_VERKAEUFER}`}
        element={<LazyKinderVerkaeuferPage />}
        exact
        key="kinderVerkaeufer"
      />

      <Route
        path={`${ROUTES.KINDERFLOHMARKT_CHECKLISTE}`}
        element={<LazyKinderflohmarktChecklistePage />}
        exact
        key="kinderFlohmarktCheckliste"
      />
      <Route
        path={`${ROUTES.ANFAENGER_TIPPS_FLOHMARKT}`}
        element={<LazyAnfaengerFlohmarktPage />}
        exact
        key="anfaengerTippsFlohmarkt"
      />
      <Route
        path={`${ROUTES.ANMELDEN_FLOHMARKT}`}
        element={<LazyAnmeldenFlohmarktPage />}
        exact
        key="anmeldenFlohmarkt"
      />
      <Route
        path={`${ROUTES.AUSSTELLER_WISSEN_LEXIKON}`}
        element={<LazyAusstellerWissenLexikonPage />}
        exact
        key="ausstellerWissenLexikon"
      />
      <Route
        path={`${ROUTES.BABYFLOHMARKT}`}
        element={<LazyBabyflohmarktPage />}
        exact
        key="babyflohmarkt"
      />
      <Route
        path={`${ROUTES.BESTEN_FLOHMAERKTE_WIEN}`}
        element={<LazyBestenFlohmaerkteWien />}
        exact
        key="bestenFlohmaerkteWien"
      />
      <Route
        path={`${ROUTES.BESTE_FLOHMAERKTE_UEBERSICHT}`}
        element={<LazyBesteFlohmaerkteUebersichtPage />}
        exact
        key="besteFlohmaerkteUebersicht"
      />
      <Route
        path={`${ROUTES.DIEBSTAHL}`}
        element={<LazyDiebstahlPage />}
        exact
        key="diebstahl"
      />
      <Route
        path={`${ROUTES.DURCHSCHNITTLICHE_EINNAHMEN}`}
        element={<LazyDurchschnittlicheEinnahmenPage />}
        exact
        key="durchschnittlicheEinnahmen"
      />
      <Route
        path={`${ROUTES.ERFOLGREICH_HANDELN}`}
        element={<LazyErfolgreichHandelnPage />}
        exact
        key="erfolgreichHandeln"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_IN_DER_NAEHE}`}
        element={<LazyFlohmarktInDerNaehePage />}
        exact
        key="flohmarktInderNaehe"
      />
      <Route
        path={`${ROUTES.LEIHTISCHE}`}
        element={<LazyLeihtischePage />}
        exact
        key="Leihtische"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_LISTE}`}
        element={<LazyFlohmarktListePage />}
        exact
        key="FlohmarktListe"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_OHNE_STANDGEBUEHR}`}
        element={<LazyFlohmarktOhneStandgebuehr />}
        exact
        key="FlohmarktOhneStandgebuehr"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_ONLINE_VERGLEICHEN}`}
        element={<LazyFlohmarktOnlineVergleichenPage />}
        exact
        key="FlohmarktOnlineVergleichen"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_PLATZ_RESERVIEREN}`}
        element={<LazyFlohmarktPlatzReservierenPage />}
        exact
        key="FlohmarktOnlineVergleichen"
      />
      <Route
        path={`${ROUTES.PREISGESTALTUNG}`}
        element={<LazyPreisgestaltungPage />}
        exact
        key="Preisgestaltung"
      />
      <Route
        path={`${ROUTES.GELD_VERDIENEN}`}
        element={<LazyGeldverdienenPage />}
        exact
        key="Geld verdienen"
      />
      <Route
        path={`${ROUTES.GENEHMIGUNG_ANMELDUNG}`}
        element={<LazyGenehmigungAnmeldungPage />}
        exact
        key="GenehmigungAnmeldung"
      />
      <Route
        path={`${ROUTES.GEWERBE_GEWERBESCHEIN}`}
        element={<LazyGewerbeGewerbescheinPage />}
        exact
        key="GewerbeGewerbeschein"
      />
      <Route
        path={`${ROUTES.GROESSTER_FLOHMARKT_WIEN}`}
        element={<LazyGroessterFlohmarktWienPage />}
        exact
        key="GroessterFlohmarktWien"
      />
      <Route
        path={`${ROUTES.HOBBY_FLOHMARKT}`}
        element={<LazyHobbyFlohmarktPage />}
        exact
        key="HobbyFlohmarkt"
      />
      <Route
        path={`${ROUTES.JETZT_STANDPLATZ_BUCHEN}`}
        element={<LazyJetztStandplatzBuchenPage />}
        exact
        key="JetztStandplatzBuchen"
      />

      <Route
        path={`${ROUTES.GIFTCARD}`}
        element={<LazyGiftCardPage />}
        exact
        key="giftCart"
      />
      <Route
        path={`${ROUTES.EVENT}`}
        element={<LazyEventListPage />}
        exact
        key="flohmarkt"
      />
      <Route
        path={`${ROUTES.AUTOMARKT}`}
        exact
        render={() => <Navigate to="/" />}
      />
      <Route
        path={`${ROUTES.BLOGAUTOKINO}`}
        element={<LazyBlogAutokinoPage />}
        exact
        key="Blog Autokino"
      />
      <Route
        path={`${ROUTES.BLOGFLOHMARKT}`}
        element={<LazyBlogFlohmarktPage />}
        exact
        key="Blog Flohmarkt"
      />
      <Route
        path={`${ROUTES.UPCOMING_MOVIES}`}
        element={<LazyUpcomingShowPage />}
        exact
        key="upcomingmovies"
      />
      <Route
        path={`${ROUTES.EVENT_ITEM}/:id`}
        element={<LazyEventPage />}
        key="event"
      />
      <Route
        path={`${ROUTES.SHOW}/:id`}
        element={<LazyShowPage />}
        key="show"
      />
      <Route
        path={`${ROUTES.MOVIE_SHOW}/:name`}
        element={<LazyShowPage />}
        key="show"
      />
      <Route
        path={`${ROUTES.EVENT_FLOHMARKT_DETAIL}/:name`}
        element={<LazyEventPage />}
        key="event"
      />
      <Route
        path={`${ROUTES.PUBLIC_EVENT_DETAIL}/:name`}
        element={<LazyEventPage />}
        key="event"
      />
      <Route
        path={`${ROUTES.MOVIE_DETAIL}/:name`}
        element={<LazyMoviePage />}
        key="movie"
      />
      <Route
        path={`${ROUTES.ORDER_STORNO}/:name`}
        element={<LazyOrderStornoPage />}
        key="orderStorno"
      />
      <Route
        path={`${ROUTES.KINDERFLOHMARKT}`}
        element={<LazyKinderflohmarktPage />}
        exact
        key="Kinderflohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_GESCHICHTE}`}
        element={<LazyGeschichtePage />}
        exact
        key="Geschichte Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_KUNDENLIEBE}`}
        element={<LazyKundenliebePage />}
        exact
        key="Kundenliebe Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_BESUCHER_TIPPS}`}
        element={<LazyBesuchertippsPage />}
        exact
        key="Besuchertipps Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_FAQ}`}
        element={<LazyFaqPage />}
        exact
        key="Fragen und Antworten zum Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.AUTOKINO_BIKE_FAQ}`}
        element={<LazyBikeFaqPage />}
        exact
        key="Fragen und Antworten zu Kinotickets für Fahrrad und Motorrad im Autokino Wien"
      />
      <Route
        path={`${ROUTES.MINIONS4_AUTOKINO}`}
        element={<LazyLandingPageMinions4Page />}
        exact
        key="Die Minions 4 im Autokino Wien"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_WINTERPAUSE}`}
        element={<LazyFMWinterpausePage />}
        exact
        key="Flohmarkt Wien - Winterpause 2024"
      />
      <Route
        path={`${ROUTES.AUTOKINO_WINTERPAUSE}`}
        element={<LazyKinoWinterpausePage />}
        exact
        key="Autokino Wien - Winterpause 2024"
      />

      <Route
        path={`${ROUTES.FLOHMARKT_MARKTORDNUNG}`}
        element={<LazyMarktordnungPage />}
        exact
        key="Marktordnung Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_CHECKLIST}`}
        element={<LazyChecklistVerkaeuferPage />}
        exact
        key="Checklist Verkäufer Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_VERKAEUFER_TIPPS}`}
        element={<LazyTippsVerkaeuferPage />}
        exact
        key="Tipps Verkäufer Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_ANREISE}`}
        element={<LazyAnreiseNewPage />}
        exact
        key="Anreise Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_FOTOS}`}
        element={<LazyFotosPage />}
        exact
        key="Fotos Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_STANDGEBUEHREN}`}
        element={<LazyStandplatzgebuehrenPage />}
        exact
        key="Standplatzgebühren Flohmarkt Autokino"
      />
      <Route
        path={`${ROUTES.CUSTOMER_FEEDBACK_FORM}`}
        element={<LazyCustomerFeedbackFormPage />}
        exact
        key="Deine Meinung zählt"
      />
      <Route
        path={`${ROUTES.CUSTOMER_FEEDBACK_FORM_SUCCESS}`}
        element={<LazySuccessPage />}
        exact
        key="Das hat geklappt!"
      />
      <Route
        path={`${ROUTES.EVENT_LOCATION}`}
        element={<LazyEventLocationPage />}
        exact
        key="Eventlocation Autokino Wien"
      />
      <Route
        path={`${ROUTES.ANREISE_AUTOKINO}`}
        element={<LazyAnreiseAutokinoPage />}
        exact
        key="Anreise Autokino Wien"
      />
      <Route
        path={`${ROUTES.FAQ_AUTOKINO}`}
        element={<LazyFaqAutokinoPage />}
        exact
        key="FAQ Autokino Wien"
      />
      <Route
        path={`${ROUTES.HAUSTIERE_AUTOKINO}`}
        element={<LazyHaustierePage />}
        exact
        key="FAQ Autokino Wien"
      />
      <Route
        path={`${ROUTES.JOBS_AUTOKINO}`}
        element={<LazyJobsPage />}
        exact
        key="Jobs Autokino Wien"
      />
      <Route
        path={`${ROUTES.PHILOSOPHIE_AUTOKINO}`}
        element={<LazyPhilosophiePage />}
        exact
        key="Philosophie Autokino Wien"
      />
      <Route
        path={`${ROUTES.OPENAIR_AUTOKINO}`}
        element={<LazyOpenAirKinoPage />}
        exact
        key="Open Air Kino Autokino Wien"
      />
      <Route
        path={`${ROUTES.SIEGERKINOTEST_AUTOKINO}`}
        element={<LazySiegerKinotestPage />}
        exact
        key="Sieger Kinotest 2022"
      />
      <Route
        path={`${ROUTES.PARTNER_AUTOKINO}`}
        element={<LazyAutokinoPartnerPage />}
        exact
        key="Partner Autokino Wien"
      />
      <Route
        path={`${ROUTES.DAS_AUTOKINO}`}
        element={<LazyDasAutokinoPage />}
        exact
        key="Das Autokino Wien"
      />
      <Route
        path={`${ROUTES.HOME}`}
        element={<LazyHomePage />}
        exact
        key="Das Autokino Wien"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_MISTELBACH}`}
        element={<LazyFlohmarktMistelbachPage />}
        exact
        key="Flohmarkt Mistelbach"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_JOBS_AUTOKINO}`}
        element={<LazyFlohmarktJobsPage />}
        exact
        key="Flohmarkt Jobs"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_NIEDEROESTERREICH}`}
        element={<LazyFlohmarktNiederoesterreichPage />}
        exact
        key="Flohmarkt Niederoesterreich"
      />
      <Route
        path={`${ROUTES.FLOHMARKT_GAENSERNDORF}`}
        element={<LazyFlohmarktGaenserndorfPage />}
        exact
        key="Flohmarkt Gänserndorf"
      />
      <Route
        path={`${ROUTES.JOBAPPLICATION_SUCCESS}`}
        element={<LazyJobApplicationSuccessPage />}
        exact
        key="Bewerbung im Autokino Wien"
      />
      <Route
        path={`${ROUTES.SHOW_NOT_FOUND}`}
        element={<LazyShowNotFoundPage />}
        exact
        key="Vorstellung nicht gefunden"
      />
      <Route
        path="/giftcard"
        element={() => <Navigate to="/kinogutschein" replace />}
      />
      <Route path="/programm" element={<Navigate to="/" replace />} />
      <Route path="/booking" element={<Navigate to="/" replace />} />
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="/index" element={<Navigate to="/" replace />} />
      <Route path="/index.html" element={<Navigate to="/" replace />} />
      <Route path="/index.php" element={<Navigate to="/" replace />} />
      <Route path="/home.php" element={<Navigate to="/" replace />} />
      <Route path="/home.html" element={<Navigate to="/" replace />} />
      <Route
        path="/news-events"
        element={<LandingPage />}
        key="landing"
      />

      <Route path={ROUTES.CART} element={<LazyCartPage />} key="cart" />
      <Route
        path="/privacy"
        element={<Redirect url={'https://autokino.at/kino/impressum-datenschutz/index.html'} />}
      />
      <Route
        path="/tiktok"
        element={<Redirect url={'https://www.tiktok.com/@autokino_wien'} />}
      />
      <Route
        path="/facebook"
        element={<Redirect url={'https://www.facebook.com/autokino.at/'} />}
      />
      <Route
        path="/facebookflohmarkt"
        element={<Redirect url={'https://www.facebook.com/FlohmarktImAutokinoWien'} />}
      />
      <Route
        path="/facebookkinderflohmarkt"
        element={<Redirect url={'https://www.facebook.com/KinderflohmarktWienAutokino'} />}
      />
      <Route
        path="/instagram"
        element={<Redirect url={'https://www.instagram.com/autokinowien/'} />}
      />
      <Route
        path="/instagramflohmarkt"
        element={<Redirect url={'https://www.instagram.com/flohmarkt_im_autokino_wien/'} />}
      />
      <Route
        path="/instagramkinderflohmarkt"
        element={<Redirect url={'https://www.instagram.com/kinderflohmarkt_wien_autokino/'} />}
      />
      <Route
        path="/sicheres-kino"
        element={<Redirect url={'https://autokino.at/kino/home-2/sicheres-kino/index.html'} />}
      />
      <Route
        path="/agb"
        element={<Redirect url={'https://autokino.at/kino/agb/index.html'} />}
      />
      <Route
        path="/dein-event-im-autokino"
        element={<Redirect url={'https://autokino.at/kino/dein-event-im-autokino/index.html'} />}
      />
      <Route
        path="/deinevent"
        element={<Redirect url={'https://autokino.at/kino/dein-event-im-autokino/index.html'} />}
      />
      <Route
        path="/aboutus"
        element={<Redirect url={'https://autokino.at/kino/geschichte/index.html'} />}
      />
      <Route
        path="/team"
        element={<Redirect url={'https://autokino.at/kino/team-partner/index.html'} />}
      />
      <Route
        path="/contact"
        element={<Redirect url={'https://autokino.at/kino/kontakt/index.html'} />}
      />
      <Route
        path="/contactprint"
        element={<Redirect url={'https://autokino.at/kino/kontakt/index.html'} />}
      />
      <Route
        path="/kontakt"
        element={<Redirect url={'https://autokino.at/kino/kontakt/index.html'} />}
      />
      <Route
        path="/geschichte"
        element={<Redirect url={'https://autokino.at/kino/kontakt/index.html'} />}
      />
      <Route
        path={ROUTES.CHECKOUT}
        element={<LazyCheckoutPage />}
        key="checkout"
      />

      <Route
        path={`${ROUTES.PAYMENT}/:id`}
        element={<LazyPaymentPage />}
        key="payment"
      />

      <Route element={<LazyNotFoundPage />} key="404" />
    </Routes>
  );
}

export default RoutesComponent;
